/* Christmas Shop 2026: "The Yachew High Street" v2. Walks the street, opens shops and advent doors.
   Desktop: the stage pins and fits the viewport; scroll walks sideways with gentle snap points at each shop.
   Mobile / reduced motion: native horizontal swipe. No third-party scripts. */
(function () {
  var d = document, html = d.documentElement, root = d.querySelector('[data-xm-st]'); if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); }, $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var stage = $('[data-st-stage]'), scroller = $('[data-st-scroller]'), street = $('[data-st-street]'), track = $('[data-st-track]'), row = $('[data-st-row]');
  var head = $('[data-st-head]'), mapbar = $('[data-st-mapbar]'), mapLine = $('[data-st-map]'), you = $('[data-st-you]'), here = $('[data-st-here]');
  var sky = $('[data-st-sky]'), fore = $('[data-st-fore]'), foreStrip = $('[data-st-fore-strip]'), postman = $('[data-st-postman]'), pmBody = $('[data-st-postman-body]'), robin = $('.xm-st__robin');
  var sprite = $('[data-st-pm-sprite]'), foreTile = 0;
  var lamps = $$('.xm-st__lamp', row), items = $$('[data-st-item]', row), shops = $$('[data-st-shop]', row), houses = $$('[data-door-house]', row);
  var mapShops = $$('.xm-st__map-shop', mapLine);
  var mqWide = matchMedia('(min-width: 900px)'), mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
  var mode = '', travel = 0, W = 0, V = 0, L = 0, x = 0, raf = 0, lastX = -1, rowW = 1, hd = 0, mh = 0, vis = -1, scale = 1, endItem = items[items.length - 1];
  var store = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function absTop(el) { return el.getBoundingClientRect().top + scrollY; }
  function openDialog() { return root.querySelector('dialog[open]'); }

  /* ── Layout ── */
  var snaps = [];
  function measure() {
    mode = mqWide.matches && !mqReduce.matches ? 'pin' : 'swipe';
    root.setAttribute('data-mode', mode);
    row.style.transform = ''; vis = -1;
    V = innerHeight;
    if (mode === 'pin') {
      // Fit the whole street (rooftops to pavement) between the header strip and the map strip.
      hd = head.offsetHeight; mh = mapbar.offsetHeight;
      var pave = parseFloat(getComputedStyle(root).getPropertyValue('--pave')) || 60;
      var H = clamp(V - hd - mh - pave * 0.55 - 14, 260, 860);
      root.style.setProperty('--H', Math.round(H) + 'px');
      root.style.setProperty('--mh', mh + 'px');
      W = stage.clientWidth;
    } else {
      root.style.removeProperty('--H'); root.style.removeProperty('--vis'); root.style.removeProperty('--s');
      W = track.clientWidth;
    }
    rowW = Math.max(1, row.scrollWidth);
    travel = Math.max(0, rowW - W);
    // Keep the whole walk to roughly 3,400px of scrolling, however long the street is.
    L = mode === 'pin' ? travel / Math.max(1.45, travel / 3400) : 0;
    scroller.style.height = mode === 'pin' ? Math.round(V + L) + 'px' : '';
    sky.style.width = Math.ceil(W + travel * 0.12 + 40) + 'px';
    lamps.forEach(function (l) { l.style.transform = ''; l._c = l.offsetLeft + l.offsetWidth / 2; });
    items.forEach(function (it) { it._c = it.offsetLeft + it.offsetWidth / 2; });
    placeMap(); placeSnaps(); fitSigns(); lastX = -1; frame();
  }

  // Gentle snapping: when scrolling comes to rest near a shopfront, ease the last few steps so it stands centred.
  // (CSS scroll-snap on the root pulled too hard here: it grabbed the page on load and fought the wheel.)
  var snaps = [], snapping = false, snapT = 0, scrollDir = 1, lastY = scrollY;
  function placeSnaps() {
    snaps = [];
    if (mode !== 'pin' || !travel) return;
    shops.forEach(function (it) { snaps.push(clamp(it._c - W / 2, 0, travel) / travel * L); });
  }
  function settle() {
    if (mode !== 'pin' || !snaps.length || openDialog() || snapping) { snapping = false; return; }
    var top = absTop(scroller), rel = scrollY - top; if (rel <= 2 || rel >= L - 2) return;
    // Only ever ease onward in the direction you were walking; never pull you back against the wheel.
    var best = null, bd = Infinity; snaps.forEach(function (sy) { var dd = (sy - rel) * scrollDir; if (dd > -3 && dd < bd) { bd = dd; best = sy; } });
    var reach = Math.min(240, L / Math.max(2, snaps.length) * 0.32);
    if (best == null || Math.abs(bd) < 3 || bd > reach) return;
    snapping = true;
    window.scrollTo({ top: Math.round(top + best), behavior: mqReduce.matches ? 'auto' : 'smooth' });
  }
  function scrolled() {
    queue();
    if (scrollY !== lastY) { if (!snapping) scrollDir = scrollY > lastY ? 1 : -1; lastY = scrollY; }
    if (mode !== 'pin') return;
    clearTimeout(snapT); snapT = setTimeout(function () { if (snapping) { snapping = false; return; } settle(); }, 180);
  }

  // Street map: shop thumbnails and door ticks at their real positions along the street.
  var ticks = [];
  function placeMap() {
    mapShops.forEach(function (a, i) { if (shops[i]) a.style.left = (shops[i]._c / rowW * 100).toFixed(2) + '%'; });
    if (!ticks.length) houses.forEach(function () { var t = d.createElement('span'); t.className = 'xm-st__map-door'; t.setAttribute('aria-hidden', 'true'); mapLine.insertBefore(t, you); ticks.push(t); });
    ticks.forEach(function (t, i) { t.style.left = (houses[i]._c / rowW * 100).toFixed(2) + '%'; });
  }

  function currentX() {
    if (mode === 'pin') { var r = scroller.getBoundingClientRect(); return L > 0 ? clamp(-r.top / L, 0, 1) * travel : 0; }
    return track.scrollLeft;
  }

  /* ── Postman ── */
  var pm = { phase: 0, dir: 1, pos: innerWidth < 700 ? 0.03 : 0.16 };
  function walkPostman(dx) {
    if (!postman) return;
    if (mqReduce.matches) { postman.style.transform = 'translate3d(' + (W * 0.14).toFixed(0) + 'px,0,0)'; pmBody.style.transform = ''; return; }
    if (dx) { pm.phase += Math.min(Math.abs(dx) * 0.09, 3.3); pm.dir = dx > 0 ? 1 : -1; } // stride rate follows scroll speed, capped at a brisk walk
    var narrow = W < 700; // on a phone he keeps to the left edge so he doesn't stand in front of the windows
    pm.pos += ((pm.dir > 0 ? (narrow ? 0.05 : 0.2) : (narrow ? 0.01 : 0.1)) - pm.pos) * Math.min(1, Math.abs(dx) / 260);
    // Six drawn poses: contact, down, passing, contact, down, passing. He rises a touch on the passing poses.
    var f = dx || pm.moving ? Math.floor(pm.phase / 14) % 6 : 0;
    if (dx && f !== pm.f && (f === 0 || f === 3)) sfx.step();
    pm.f = f;
    var lift = f === 2 || f === 5 ? 3 : f === 1 || f === 4 ? -1 : 0;
    postman.style.transform = 'translate3d(' + (pm.pos * W / scale).toFixed(1) + 'px,0,0)';
    pmBody.style.transform = 'translate3d(0,' + (-lift) + 'px,0) scaleX(' + pm.dir + ')';
    if (sprite) sprite.style.backgroundPosition = (f * 20) + '% 0';
  }
  // When the walking stops he finishes his step and stands in the first pose.
  var pmRest = 0;
  function restPostman() { pm.moving = false; walkPostman(0); }

  function frame() {
    raf = 0;
    if (mode === 'pin') {
      var st = stage.getBoundingClientRect().top, v = Math.round(V - Math.max(0, st));
      if (v !== vis) {
        vis = v; root.style.setProperty('--vis', v + 'px');
        scale = clamp((v - hd - mh) / Math.max(1, V - hd - mh), 0.45, 1); root.style.setProperty('--s', scale.toFixed(4));
      }
    } else scale = 1;
    x = currentX(); if (x === lastX) return;
    var dx = lastX < 0 ? 0 : x - lastX; lastX = x;
    if (mode === 'pin') row.style.transform = 'translate3d(' + (-x).toFixed(1) + 'px,0,0)';
    if (!mqReduce.matches) {
      sky.style.transform = 'translate3d(' + (-x * 0.12).toFixed(1) + 'px,0,0)';
      if (foreStrip) { var fx = x * 1.18; if (foreTile) fx = fx % foreTile; foreStrip.style.transform = 'translate3d(' + (-fx).toFixed(1) + 'px,0,0)'; }
      lamps.forEach(function (l) { l.style.transform = 'translate3d(' + ((l._c - x - W / 2) * -0.08).toFixed(1) + 'px,0,0)'; });
      snowShift(dx);
    }
    walkPostman(dx);
    if (dx) pm.moving = true; clearTimeout(pmRestT); pmRestT = setTimeout(restPostman, 240);
    spy();
  }
  var pmRestT = 0;
  function queue() { if (!raf) raf = requestAnimationFrame(frame); }

  // Which shop are we standing outside? Drives the map marker, "You are here" and aria-current.
  var curShop = null;
  function spy() {
    var mid = x + W / 2 / scale, pick = null, best = Infinity;
    shops.forEach(function (it) { var dd = Math.abs(it._c - mid); if (dd < best) { best = dd; pick = it; } });
    you.style.left = (clamp(mid / rowW, 0, 1) * 100).toFixed(2) + '%';
    var near = pick && best < W * 0.42 ? pick : null;
    if (near !== curShop) {
      curShop = near;
      mapShops.forEach(function (a, i) { a.setAttribute('aria-current', shops[i] === near ? 'location' : 'false'); });
    }
    var label = near ? near.getAttribute('data-st-name') : (endItem && Math.abs(endItem._c - mid) < W * 0.4 ? 'The end of the street' : 'The advent doors');
    if (here.textContent !== label) here.textContent = label;
  }

  // Walk to an item (map, keyboard, end-of-street button)
  function walkTo(el, smooth) {
    var tx = !el || el.id === 'xm-st-start' ? 0 : clamp(el._c - W / 2, 0, travel);
    var behavior = smooth && !mqReduce.matches ? 'smooth' : 'auto';
    if (mode === 'pin') { window.scrollTo({ top: absTop(scroller) + (travel ? tx / travel : 0) * L, behavior: behavior }); }
    else { var top = absTop(stage); if (Math.abs(top - scrollY) > innerHeight * 0.6) window.scrollTo({ top: top - 20, behavior: behavior }); track.scrollTo({ left: tx, behavior: behavior }); }
  }
  function stepShop(dir) {
    var mid = x + W / 2 / scale, stops = shops.concat(endItem ? [endItem] : []).sort(function (a, b) { return a._c - b._c; });
    var next = dir > 0 ? stops.filter(function (it) { return it._c > mid + 24; })[0] : stops.filter(function (it) { return it._c < mid - 24; }).pop();
    if (!next && dir < 0) next = { id: 'xm-st-start' };
    if (next) walkTo(next, true);
  }
  root.addEventListener('click', function (e) {
    var go = e.target.closest('[data-st-go]');
    if (go) { e.preventDefault(); var id = go.getAttribute('data-st-go'); walkTo(id === 'xm-st-start' ? { id: id } : d.getElementById(id), true); return; }
    var step = e.target.closest('[data-st-step]'); if (step) stepShop(+step.getAttribute('data-st-step'));
  });
  // Left/right arrow keys walk shop to shop while the street is on screen.
  d.addEventListener('keydown', function (e) {
    if ((e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || openDialog()) return;
    var t = e.target; if (t && (t.isContentEditable || /^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName))) return;
    var r = stage.getBoundingClientRect(); if (r.bottom < innerHeight * 0.4 || r.top > innerHeight * 0.6) return;
    e.preventDefault(); stepShop(e.key === 'ArrowRight' ? 1 : -1);
  });
  // In pinned mode the street is translated, so bring whatever takes focus into view.
  row.addEventListener('focusin', function (e) {
    if (mode !== 'pin') return; var it = e.target.closest('[data-st-item]'); if (!it) return;
    var sx = it._c - x; if (sx < 60 || sx > W - 60) walkTo(it, false);
  });

  // Fit sign text on its painted board.
  function fitSigns() {
    $$('.xm-st__sign span', row).forEach(function (s) {
      s.style.fontSize = ''; var box = s.parentNode.clientWidth * 0.9; var w = s.scrollWidth;
      if (w > box && box > 0) s.style.fontSize = (parseFloat(getComputedStyle(s).fontSize) * box / w).toFixed(1) + 'px';
    });
  }

  /* ── Snow ── */
  var cv = $('[data-st-snow]'), ctx = cv && cv.getContext && cv.getContext('2d'), flakes = [], snowOn = false, visible = true, sraf = 0, last = 0;
  function sizeSnow() {
    if (!ctx) return; var dpr = Math.min(devicePixelRatio || 1, 2), w = stage.clientWidth, h = stage.clientHeight;
    cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var n = Math.round(clamp(w * h / 9000, 40, mqWide.matches ? 130 : 60));
    flakes = []; for (var i = 0; i < n; i++) flakes.push(newFlake(w, h, true));
  }
  function newFlake(w, h, anywhere) { var z = Math.random(); return { x: Math.random() * w, y: anywhere ? Math.random() * h : -6, r: 0.6 + z * 2.2, v: 14 + z * 38, s: Math.random() * 6.28, a: 0.35 + z * 0.55, z: z }; }
  function snowShift(dx) { if (!dx) return; for (var i = 0; i < flakes.length; i++) flakes[i].x -= dx * (0.3 + flakes[i].z * 0.9); }
  function snow(t) {
    sraf = 0; if (!snowOn || !visible || d.hidden) return;
    var dt = Math.min(0.05, last ? (t - last) / 1000 : 0.016); last = t;
    var w = stage.clientWidth, h = stage.clientHeight; ctx.clearRect(0, 0, w, h); ctx.fillStyle = '#fff';
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i]; f.y += f.v * dt; f.s += dt * (0.6 + f.z); f.x += Math.sin(f.s) * 0.3 + gust * (60 + f.z * 160) * dt;
      if (f.y > h + 6) { flakes[i] = newFlake(w, h, false); continue; }
      if (f.x < -8) f.x += w + 16; else if (f.x > w + 8) f.x -= w + 16;
      ctx.globalAlpha = f.a; ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill();
    }
    ctx.globalAlpha = 1; sraf = requestAnimationFrame(snow);
  }
  function startSnow() { if (!ctx) return; snowOn = !mqReduce.matches; if (!snowOn) { ctx.clearRect(0, 0, cv.width, cv.height); return; } if (!sraf) { last = 0; sraf = requestAnimationFrame(snow); } }
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) startSnow(); }, { threshold: 0 }).observe(stage);
  d.addEventListener('visibilitychange', function () { if (!d.hidden) startSnow(); });

  /* ── Robin: now and then hops onto the sign of the shop you are looking at ── */
  var robinBusy = false;
  function robinVisit() {
    setTimeout(robinVisit, 9000 + Math.random() * 9000);
    if (!robin || robinBusy || mqReduce.matches || !visible || d.hidden || openDialog() || !robin.complete || !robin.animate) return;
    var mid = x + W / 2 / scale, on = shops.filter(function (s) { return Math.abs(s._c - mid) < W * 0.34 && !s.classList.contains('is-teaser'); })[0];
    if (!on) return;
    robinBusy = true;
    on.appendChild(robin);
    var f = 0.15 + Math.random() * 0.6, back = Math.random() < 0.5 ? -1 : 1;
    robin.style.left = 'calc(var(--sx) + var(--sw) * ' + f.toFixed(2) + ')';
    robin.hidden = false;
    var inA = robin.animate([
      { transform: 'translate(' + (back * 120) + 'px,-90px) scaleX(' + back + ')', opacity: 0 },
      { transform: 'translate(' + (back * 60) + 'px,-60px) scaleX(' + back + ')', opacity: 1, offset: 0.35 },
      { transform: 'translate(' + (back * 18) + 'px,-26px) scaleX(' + back + ')', offset: 0.7 },
      { transform: 'translate(0,0) scaleX(' + back + ') scaleY(.9)', offset: 0.9 },
      { transform: 'translate(0,0) scaleX(' + back + ')', opacity: 1 }
    ], { duration: 900, easing: 'ease-out', fill: 'forwards' });
    inA.onfinish = function () {
      var bob = robin.animate([{ transform: 'scaleX(' + back + ') rotate(0deg)' }, { transform: 'scaleX(' + back + ') rotate(-8deg)', offset: 0.2 }, { transform: 'scaleX(' + back + ') rotate(0deg)', offset: 0.4 }, { transform: 'scaleX(' + back + ') translateY(-6px)', offset: 0.7 }, { transform: 'scaleX(' + back + ') rotate(0deg)' }], { duration: 1400, delay: 1200, iterations: 2 });
      bob.onfinish = function () {
        var out = robin.animate([{ transform: 'translate(0,0) scaleX(' + back + ')', opacity: 1 }, { transform: 'translate(' + (-back * 50) + 'px,-50px) scaleX(' + (-back) + ')', opacity: 1, offset: 0.5 }, { transform: 'translate(' + (-back * 140) + 'px,-120px) scaleX(' + (-back) + ')', opacity: 0 }], { duration: 800, easing: 'ease-in', fill: 'forwards' });
        out.onfinish = function () { robin.hidden = true; inA.cancel(); out.cancel(); robinBusy = false; };
      };
    };
  }
  if (robin) { robin.hidden = true; setTimeout(robinVisit, 3500); }

  /* ── Shop bell: Web Audio, off by default; shares the 'xm26-sound' setting with the cracker ── */
  var soundBtn = $('[data-st-sound]'), soundLbl = $('[data-st-sound-label]'), ac = null;
  var soundBase = soundLbl ? soundLbl.textContent.replace(/:\s*off$/i, '') : 'Shop bell';
  function soundOn() { return store.get('xm26-sound') === '1'; }
  function paintSound() { if (!soundBtn) return; soundBtn.setAttribute('aria-pressed', soundOn() ? 'true' : 'false'); soundLbl.textContent = soundBase + ': ' + (soundOn() ? 'on' : 'off'); }
  /* Sound kit: all synthesised with Web Audio (no files), only after the shopper turns sound on.
     Only ever in answer to something the shopper does (walk, open, add); nothing plays on its own. */
  var noiseBuf = null;
  function audio() { if (!soundOn()) return null; try { ac = ac || new (window.AudioContext || window.webkitAudioContext)(); if (ac.state === 'suspended') ac.resume(); return ac; } catch (e) { return null; } }
  function envl(a, t, peak, atk, dec, to) { var g = a.createGain(); g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + atk); g.gain.exponentialRampToValueAtTime(0.0001, t + atk + dec); g.connect(to || a.destination); return g; }
  function tone(a, t, f, peak, dec, type, to) { var o = a.createOscillator(); o.type = type || 'sine'; o.frequency.value = f; o.connect(envl(a, t, peak, 0.004, dec, to)); o.start(t); o.stop(t + dec + 0.06); return o; }
  function noise(a) { if (!noiseBuf) { noiseBuf = a.createBuffer(1, a.sampleRate, a.sampleRate); var ch = noiseBuf.getChannelData(0); for (var i = 0; i < ch.length; i++) ch[i] = Math.random() * 2 - 1; } var n = a.createBufferSource(); n.buffer = noiseBuf; return n; }
  function filt(a, type, f, q, to) { var b = a.createBiquadFilter(); b.type = type; b.frequency.value = f; b.Q.value = q || 0.7; b.connect(to); return b; }
  var sfx = {
    // shop door bell: three strikes of a small brass bell
    bell: function () { var a = audio(); if (!a) return;
      [0, 0.14, 0.3].forEach(function (at, k) { var t = a.currentTime + at, peak = [0.09, 0.06, 0.035][k];
        [[2093, 1], [2093 * 2.76, 0.35], [2093 * 5.4, 0.12]].forEach(function (pp) { tone(a, t, pp[0] * (1 + (k - 1) * 0.004), peak * pp[1], 1.1); }); }); },
    // a boot in fresh snow: a short band of filtered noise, a little different each time
    step: function () { var a = audio(); if (!a) return; var t = a.currentTime, n = noise(a);
      n.connect(filt(a, 'bandpass', 700 + Math.random() * 600, 0.9, envl(a, t, 0.045, 0.012, 0.11))); n.start(t, Math.random() * 0.7, 0.16); },
    // till drawer and bell when something goes in the basket
    till: function () { var a = audio(); if (!a) return; var t = a.currentTime, n = noise(a);
      n.connect(filt(a, 'highpass', 2500, 0.7, envl(a, t, 0.05, 0.002, 0.05))); n.start(t, 0, 0.08);
      tone(a, t + 0.06, 1568, 0.07, 0.9); tone(a, t + 0.06, 1568 * 2.4, 0.02, 0.5); tone(a, t + 0.17, 2093, 0.06, 1.1); },
    // an old wooden door easing open
    creak: function () { var a = audio(); if (!a) return; var t = a.currentTime, o = a.createOscillator(), lp = filt(a, 'bandpass', 900, 3, envl(a, t, 0.05, 0.08, 0.5));
      o.type = 'sawtooth'; o.frequency.setValueAtTime(70, t); o.frequency.linearRampToValueAtTime(115, t + 0.25); o.frequency.linearRampToValueAtTime(88, t + 0.55);
      var lfo = a.createOscillator(), lg = a.createGain(); lfo.frequency.value = 23; lg.gain.value = 18; lfo.connect(lg); lg.connect(o.frequency);
      o.connect(lp); o.start(t); lfo.start(t); o.stop(t + 0.7); lfo.stop(t + 0.7); },
    // knock on a door that isn't ready yet
    knock: function () { var a = audio(); if (!a) return; [0, 0.16].forEach(function (at) { var t = a.currentTime + at, o = a.createOscillator();
      o.type = 'triangle'; o.frequency.setValueAtTime(170, t); o.frequency.exponentialRampToValueAtTime(70, t + 0.09); o.connect(envl(a, t, 0.12, 0.003, 0.12)); o.start(t); o.stop(t + 0.2); }); },
    // sleigh bells passing overhead: quick bright jingles, louder in the middle
    sleigh: function (dur) { var a = audio(); if (!a) return; var t0 = a.currentTime, n = Math.round((dur || 4) * 9);
      for (var i = 0; i < n; i++) { var f = i / n, t = t0 + f * (dur || 4) + Math.random() * 0.04, v = 0.012 + 0.03 * Math.sin(Math.PI * f);
        tone(a, t, 2600 + Math.random() * 1600, v, 0.18); tone(a, t + 0.01, 5200 + Math.random() * 1800, v * 0.5, 0.1); } },
    // a gust of wind down the street
    gust: function () { var a = audio(); if (!a) return; var t = a.currentTime, n = noise(a), g = a.createGain(), bp = filt(a, 'bandpass', 380, 1.4, g);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.03, t + 0.9); g.gain.exponentialRampToValueAtTime(0.0001, t + 2.6); g.connect(a.destination);
      bp.frequency.setValueAtTime(280, t); bp.frequency.linearRampToValueAtTime(620, t + 1.2); bp.frequency.linearRampToValueAtTime(320, t + 2.6);
      n.loop = true; n.connect(bp); n.start(t); n.stop(t + 2.7); }
  };
  function bell() { sfx.bell(); }
  if (soundBtn) {
    paintSound();
    soundBtn.addEventListener('click', function () { store.set('xm26-sound', soundOn() ? '0' : '1'); paintSound(); if (soundOn()) bell(); if (window.xm26Track) window.xm26Track('xmas26_sound', { on: soundOn() }); });
    addEventListener('storage', function (e) { if (e.key === 'xm26-sound') paintSound(); });
  }

  /* ── Dialogs: lock the page behind them (overflow on <body> propagates to the viewport, so the pinned street keeps its place) ── */
  var lastFocus = null;
  function lock(on) { html.classList.toggle('xm-st-lock', on); }
  function openDlg(dlg) {
    if (!dlg) return; lastFocus = d.activeElement;
    if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    lock(true); syncTix();
    if (dlg.classList.contains('xm-st-in--post')) syncCountry(dlg);
    if (dlg.hasAttribute('data-st-bell')) bell();
    if (window.xm26Track) window.xm26Track(dlg === doorDlg ? 'xmas26_door_open' : 'xmas26_shop_open', { xm_place: dlg.getAttribute('data-decor') || (dlg.querySelector('[data-st-door-num]') || {}).textContent || dlg.id });
    if (dlg.hasAttribute('data-st-cracker-panel')) d.dispatchEvent(new CustomEvent('xm26:cracker-shop', { detail: { panel: dlg } }));
    var sc = dlg.querySelector('.xm-st-in__inner'); if (sc) sc.scrollTop = 0;
  }
  function closeDlg(dlg) { if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); } }
  $$('dialog').forEach(function (dlg) {
    dlg.addEventListener('close', function () {
      $$('.xm-st__door.is-open').forEach(function (b) { b.classList.remove('is-open'); b.classList.add('is-ajar'); });
      if (!openDialog()) lock(false);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(dlg); if (e.target.closest('[data-st-close]')) closeDlg(dlg); });
  });
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-st-open]'); if (!o) return; e.preventDefault(); openDlg(d.getElementById(o.getAttribute('data-st-open')));
  });
  // The order-by line's "All countries" link opens the Post Office.
  var post = $('.xm-st-in--post');
  d.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href="#when-to-order"]'); if (a && post) { e.preventDefault(); $$('dialog[open]').forEach(function (x) { if (x !== post) closeDlg(x); }); openDlg(post); } });

  // Post Office country box mirrors the header's country picker (xm26.js owns #xm-country).
  function syncCountry(dlg) {
    var main = d.getElementById('xm-country'), mine = dlg.querySelector('[data-st-country]'); if (!main || !mine) return;
    if (mine.options.length !== main.options.length) mine.innerHTML = main.innerHTML;
    mine.value = main.value;
    if (!mine._bound) { mine._bound = true; mine.addEventListener('change', function () { main.value = mine.value; main.dispatchEvent(new Event('change', { bubbles: true })); }); }
  }

  // The spend bar (xm26-basket) sits under a modal's backdrop, so each panel shows its own copy of the ticket line.
  var bEl = d.querySelector('[data-xm-basket]'), tixes = $$('[data-st-tix]');
  function syncTix() {
    if (!tixes.length) return;
    var on = !!(bEl && !bEl.hidden && bEl.classList.contains('is-on'));
    var msg = on ? bEl.querySelector('.xm-basket__msg') : null, note = on ? bEl.querySelector('.xm-basket__note') : null, bar = on ? bEl.querySelector('.xm-basket__track i') : null;
    tixes.forEach(function (t) {
      t.hidden = !on; if (!on) return;
      t.querySelector('[data-st-tix-msg]').innerHTML = msg ? msg.innerHTML : '';
      t.querySelector('[data-st-tix-note]').textContent = note ? note.textContent : '';
      t.querySelector('[data-st-tix-bar]').style.width = bar ? bar.style.width : '0';
      t.classList.toggle('is-added', bEl.classList.contains('is-added'));
    });
  }
  if (bEl && window.MutationObserver) { var tt; new MutationObserver(function () { clearTimeout(tt); tt = setTimeout(syncTix, 30); }).observe(bEl, { attributes: true, attributeFilter: ['class', 'hidden', 'style'], subtree: true, childList: true, characterData: true }); }

  /* ── Advent doors ── */
  var doorDlg = $('[data-st-door-dlg]'), serverDay = +root.getAttribute('data-day') || 0, year = +root.getAttribute('data-year') || 2026;
  var londonDay = (function () {
    try { var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date()), g = function (t) { return +p.filter(function (q) { return q.type === t; })[0].value; };
      if (g('year') === year && g('month') === 12) return Math.min(g('day'), 25); if (g('year') > year) return 25; } catch (e) {}
    return 0;
  })();
  // Content is only in the page up to the server's tomorrow, so the browser clock can move us on one day at most.
  var today = Math.max(serverDay, Math.min(londonDay, serverDay + 1));
  var opened = (store.get('xm26-st-doors') || '').split(',').filter(Boolean).map(Number);
  var dateFmt = function (n) { try { return new Date(Date.UTC(year, 11, n)).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }); } catch (e) { return n + ' December'; } };
  $$('[data-st-door]').forEach(function (b) {
    var n = +b.getAttribute('data-st-door'), has = !!root.querySelector('template[data-st-door-content="' + n + '"]');
    var live = n <= today && has;
    b.classList.toggle('is-locked', !live);
    b.classList.toggle('is-today', live && n === today);
    if (live && n < today && opened.indexOf(n) > -1) b.classList.add('is-ajar');
    b.setAttribute('aria-label', 'Advent door ' + n + (live ? (n === today ? ', today’s door' : '') : ', opens ' + dateFmt(n)));
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-st-door]'); if (!b) return;
    var n = +b.getAttribute('data-st-door'), tpl = root.querySelector('template[data-st-door-content="' + n + '"]');
    var live = n <= today && tpl, body = doorDlg.querySelector('[data-st-door-body]');
    doorDlg.querySelector('[data-st-door-num]').textContent = n;
    if (live) {
      doorDlg.querySelector('[data-st-door-title]').textContent = n === today ? 'Today’s door' : 'Door ' + n;
      body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true));
      if (opened.indexOf(n) < 0) { opened.push(n); store.set('xm26-st-doors', opened.join(',')); }
      b.classList.remove('is-ajar'); b.classList.add('is-open'); sfx.creak();
      setTimeout(function () { openDlg(doorDlg); }, mqReduce.matches ? 0 : 520);
    } else {
      var pre = today === 0;
      doorDlg.querySelector('[data-st-door-title]').textContent = pre ? 'Door ' + n : 'Not yet';
      if (pre) { body.innerHTML = ''; body.appendChild($('template[data-st-locked-pre]').content.cloneNode(true)); var ld = body.querySelector('.xm-st-door__lead'); if (ld) ld.textContent = 'Opens ' + dateFmt(n); }
      else body.innerHTML = '<p class="xm-st-door__lead">Door ' + n + ' opens on ' + dateFmt(n) + '.</p><p class="xm-st-door__text">Come back then. Today’s door is number ' + Math.min(today, 24) + '.</p>';
      sfx.knock(); openDlg(doorDlg);
    }
  });

  /* ── Wire up ── */
  var lastW = innerWidth, lastH = innerHeight;
  function sizeFore() {
    if (!foreStrip) return;
    var m = (getComputedStyle(root).getPropertyValue('--snowbank') || '').match(/url\(['"]?([^'")]+)/); if (!m) return;
    var im = new Image(); im.onload = function () { foreTile = fore.clientHeight * im.naturalWidth / im.naturalHeight; root.style.setProperty('--tile', Math.ceil(foreTile) + 'px'); lastX = -1; queue(); }; im.src = m[1];
  }
  function resized() { lastW = innerWidth; lastH = innerHeight; measure(); sizeSnow(); startSnow(); sizeFore(); }
  var rt; addEventListener('resize', function () {
    // Mobile browsers resize the viewport as the address bar shows and hides; only re-lay the street for real changes.
    if (mode === 'swipe' && innerWidth === lastW && Math.abs(innerHeight - lastH) < 140) return;
    clearTimeout(rt); rt = setTimeout(resized, 120);
  }, { passive: true });
  addEventListener('scroll', scrolled, { passive: true });
  track.addEventListener('scroll', queue, { passive: true });
  [mqWide, mqReduce].forEach(function (m) { if (m.addEventListener) m.addEventListener('change', resized); });
  // Images decide item widths; re-measure as they arrive.
  $$('img', row).forEach(function (img) { if (!img.complete) img.addEventListener('load', function () { clearTimeout(rt); rt = setTimeout(measure, 60); }, { once: true }); });
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { clearTimeout(rt); rt = setTimeout(measure, 30); });
  resized();
  /* ── Street life: twinkling stars, gusts of wind, and now and then Father Christmas overhead ── */
  (function () {
    if (mqReduce.matches) return;
    var frag = d.createDocumentFragment();
    for (var i = 0; i < 22; i++) { var st = d.createElement('i'); st.className = 'xm-st__star';
      st.style.cssText = 'left:' + (Math.random() * 100).toFixed(1) + '%;top:' + (2 + Math.random() * 34).toFixed(1) + '%;animation-delay:' + (-Math.random() * 6).toFixed(2) + 's;animation-duration:' + (2.6 + Math.random() * 3.4).toFixed(2) + 's;--sz:' + (1.2 + Math.random() * 1.8).toFixed(1) + 'px';
      frag.appendChild(st); }
    sky.appendChild(frag);
  })();
  var gust = 0;
  function gustLoop() {
    setTimeout(gustLoop, 16000 + Math.random() * 14000);
    if (mqReduce.matches || !visible || d.hidden || openDialog()) return;
    var t0 = performance.now(), dir = Math.random() < 0.5 ? -1 : 1; // silent: ambient sounds that play on their own read as odd background music
    (function g(t) { var k = (t - t0) / 2600; gust = k >= 1 ? 0 : dir * Math.sin(Math.PI * k); if (k < 1) requestAnimationFrame(g); })(t0);
  }
  setTimeout(gustLoop, 9000);
  var sleighSrc = root.getAttribute('data-sleigh'), sleighEl = null;
  function sleighLoop(first) {
    setTimeout(sleighLoop, 38000 + Math.random() * 26000);
    if (!sleighSrc || mqReduce.matches || !visible || d.hidden || openDialog() || !stage.animate) return;
    if (!sleighEl) { sleighEl = new Image(); sleighEl.src = sleighSrc; sleighEl.alt = ''; sleighEl.className = 'xm-st__sleigh'; sleighEl.setAttribute('aria-hidden', 'true'); stage.appendChild(sleighEl); }
    if (!sleighEl.complete) { sleighEl.onload = function () { sleighEl.onload = null; fly(); }; return; }
    fly();
    function fly() {
      var w = stage.clientWidth, sw = sleighEl.offsetWidth || w * 0.3, dur = 9000 + Math.random() * 3000, y0 = 24 + Math.random() * 6; // starts low behind the chimneys, climbs away over the roofs
      sleighEl.style.top = y0 + '%';
      sleighEl.animate([
        { transform: 'translate3d(' + (-sw - 20) + 'px, 30px, 0) rotate(-6deg)', opacity: 0 },
        { opacity: 0.95, offset: 0.08 },
        { transform: 'translate3d(' + (w * 0.35) + 'px, -30px, 0) rotate(-4deg)', offset: 0.4 },
        { transform: 'translate3d(' + (w * 0.7) + 'px, -90px, 0) rotate(-7deg)', opacity: 0.95, offset: 0.8 },
        { transform: 'translate3d(' + (w + 20) + 'px, -150px, 0) rotate(-9deg)', opacity: 0 }
      ], { duration: dur, easing: 'linear' });
    }
  }
  setTimeout(sleighLoop, 7000);
  // Something going into the basket rings the till.
  d.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-xm-add]'); if (b && (root.contains(b) || b.closest('.xm-st-in, .xm-st-door'))) setTimeout(sfx.till, 120); });

  // On a phone, start outside the first shop rather than on the first two doors.
  if (mode === 'swipe' && !track.scrollLeft && shops[0]) track.scrollLeft = clamp(shops[0]._c - W / 2, 0, travel);

})();

  /* The rebuilt cracker (section xm26-crk, practice mode) lives inside The Cracker Shop when the template includes it. */
(function () {
  var d = document;
    var crk = d.querySelector('.xm-crk'), slot = d.querySelector('[data-st-cracker-slot]');
    if (!crk || !slot) return;
    var holder = crk.closest('.shopify-section') || crk;
    slot.innerHTML = ''; slot.classList.add('has-crk'); slot.appendChild(holder);
    d.body.classList.add('xm-st-has-crk');
    var shop = d.querySelector('[data-st-cracker]');
    if (shop) { var btn = shop.matches('button') ? shop : shop.querySelector('button[aria-label]'); if (btn) btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace(/coming soon/i, 'step inside and pull a cracker')); }
  })();
